var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPicDb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 131,
    viewBox: "0 0 298 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7375 502.886C-22.7043 424.91 29.2394 342.504 50.5705 259.972C72.2445 176.114 63.1681 72.7678 135.299 24.8182C209.058 -24.2145 305.056 11.4059 390.737 33.8418C477.144 56.4676 571.534 76.6762 619.962 151.728C670.002 229.279 668.745 330.329 638.26 417.443C609.811 498.738 539.483 552.628 464.71 595.375C390.355 637.883 308.5 671.071 224.583 653.937C135.97 635.843 48.2793 585.617 11.7375 502.886Z",
    fill: "#FBE8E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicDb);
export default __webpack_public_path__ + "static/media/picDB.e285e5c8c11e758e7b16f7f2fb4fd3b4.svg";
export { ForwardRef as ReactComponent };